var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "results" }, [
    _vm.result.graphs
      ? _c("div", { staticClass: "result-detail-summary" }, [
          _c("div", { staticClass: "overall-result" }, [
            _c("div", { staticClass: "results-pill" }, [
              _vm._v(" Pass: " + _vm._s(_vm.result.pass || 0) + " "),
            ]),
          ]),
          _c("div", { staticClass: "overall-result" }, [
            _c("div", { staticClass: "results-pill results-pill--fail" }, [
              _vm._v(" Fail: " + _vm._s(_vm.result.fail || 0) + " "),
            ]),
          ]),
          _c("div", { staticClass: "overall-result" }, [
            _c("div", { staticClass: "results-pill results-pill--rate" }, [
              _vm._v(
                " Pass Rate: " + _vm._s(_vm.getPassRate(_vm.result) + "%") + " "
              ),
            ]),
          ]),
          _c("div", { staticClass: "result-date" }, [
            _vm._m(0),
            _c("div", [_vm._v(_vm._s(_vm.result.as_of))]),
          ]),
          _vm.result.graphs
            ? _c(
                "button",
                {
                  staticClass: "button button-secondary button-outline",
                  attrs: { disabled: _vm.downloading },
                  on: {
                    click: function ($event) {
                      return _vm.download()
                    },
                  },
                },
                [
                  !_vm.downloading
                    ? _c("i", { staticClass: "material-icons" }, [
                        _vm._v("get_app"),
                      ])
                    : _vm._e(),
                  _vm.downloading
                    ? _c("div", { staticClass: "labs-loader" })
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.result.graphs
      ? _c("div", { staticClass: "result-nav" }, [
          _c("div", { ref: "inner-nav", staticClass: "result-nav__inner" }, [
            _c(
              "div",
              { ref: "scroll-nav", staticClass: "result-nav__scroll" },
              _vm._l(_vm.result.graphs, function (graph, graphIndex) {
                return _c(
                  "div",
                  {
                    key: "attr_" + graphIndex,
                    staticClass: "result-link",
                    class: {
                      "result-link--active":
                        graphIndex === _vm.selectedGraphIndex,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setSelectedGraphIndex(graphIndex)
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.attributesDisplayMap[graph.attribute] ||
                            graph.attribute
                        ) +
                        " "
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ])
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "result-detail",
        class: { "result-detail--empty": !_vm.result.graphs },
      },
      [
        _c(
          "div",
          { staticClass: "result-detail-chart" },
          [
            _vm.result.graphs
              ? _c("StackedBarChart", {
                  attrs: { graphIndex: _vm.selectedGraphIndex },
                  on: { download: _vm.download },
                })
              : _vm._e(),
            !_vm.result.graphs && !_vm.calculating
              ? _c("div", { staticClass: "result-detail-chart__empty" }, [
                  _c("span", { staticClass: "icon-analytics-bars" }),
                  _c("p", [
                    _vm._v(" The results of your profile will appear here. "),
                  ]),
                ])
              : _vm._e(),
            _vm.calculating
              ? _c("div", { staticClass: "labs-loader-container" }, [
                  _c("div", { staticClass: "labs-loader" }),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [_c("strong", [_vm._v("Results as of")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }